<router-outlet *ngIf="IsPortalInitialized; else loading;"></router-outlet>
<ng-template #loading>
    <div class="cManikBoxLoaderParent" *ngIf="DomainName !== 'emcity.ae'; else empayloader">
        <div style="text-align: center;"> 
            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding-top:10%;">
        </div>
        <!-- <div class="cManikBoxLoader">
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div> -->
    </div>
    <ng-template #empayloader>
        <div class="cEmpayloader">
            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/empay/loader/emcity_loader.gif">
        </div>
    </ng-template>
</ng-template>
<!-- <router-outlet></router-outlet> -->